import { View, Text } from 'react-native'
import React from 'react'
import Svg, { Path } from 'react-native-svg'; // Import the necessary components


export default function MenuBar({ color }) {
    return (
        <View>
            <Svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 24 24" fill={color}>
                <Path d="M5 7H19" stroke="#222222" stroke-linecap="round" />
                <Path d="M5 12H15" stroke="#222222" stroke-linecap="round" />
                <Path d="M5 17H11" stroke="#222222" stroke-linecap="round" />
            </Svg>
        </View>
    )
}